import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { WebhooksComponent } from './pages/webhooks/webhooks.component';

const routes: Routes = [{ path: '', component: WebhooksComponent }]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WebhookRoutingModule { }
